import React from "react";

function SessionStat(props) {
    return (
        <div className="stat-row">
            <div className="stat-title">
                {props.title}
            </div>
            <StatHighlightBar primaryFill={props.primaryFill} secondaryFill={props.secondaryFill} goalValue={props.goalValue} />
            <div className="stat-values-text">
                {props.legendText}
            </div>
        </div>
    )
}
function StatHighlightBar(props) {
    // Total Width is either 200 pixels or props.width
    const totalWidth = props.width ? props.width : 200;
    const primaryPercentComplete = Math.min(props.primaryFill / props.goalValue * 100, 100);
    const secondaryPercentComplete = Math.min(props.secondaryFill / props.goalValue * 100, 100);

    const primaryBarStyle = {
        width: primaryPercentComplete + "%"
    }
    const secondaryBarStyle = {
        width: secondaryPercentComplete + "%"
    }

    return (
        <div className="stat-highlight-bar" style={{ width: totalWidth }}>
            <div className="stat-highlight-bar-fill" style={primaryBarStyle}>
            </div>
            <div className="stat-highlight-bar-secondary-fill" style={secondaryBarStyle}>
            </div>
        </div>
    )
}

export { SessionStat };